
export const useProductPageExperiment = () => {
  // @todo: Always return "true" for the product_retails experiment.
  // Keep the hook and logic for quick rollback if needed.

  return {
    experimentIsActive: true,
  };
};
